var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-12" },
    [
      _c("hr", {
        staticClass: "w-px bg-n-gray border border-n-gray w-full mt-12 mb-12",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col md:flex-row" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.showCreatePastEventButtons
          ? _c("div", { staticClass: "w-full md:w-3/4 mb-6 md:mb-0" }, [
              _c(
                "div",
                { staticClass: "flex flex-col md:flex-row justify-end" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "button button__medium flex-auto md:flex-initial",
                      attrs: { to: { name: "event-create" } },
                    },
                    [_vm._v("\n          Create new event\n        ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-0 md:ml-3 mb-3 md:mb-0" }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "button button-secondary button__medium flex-auto md:flex-initial",
                      attrs: { to: { name: "past-event-list" } },
                    },
                    [_vm._v("\n          See past events\n        ")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          !_vm.user.action_flags.has_read_event_guide
            ? [
                _c(
                  "div",
                  { staticClass: "text-n-gray-dark text-2xl font-hairline" },
                  [
                    _vm._v(
                      "\n        As a new member of our community, please read "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "underline",
                        on: {
                          click: function ($event) {
                            _vm.modalOpen = true
                          },
                        },
                      },
                      [_vm._v("our brief guide")]
                    ),
                    _vm._v(
                      "\n        before creating your first event.\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mt-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button button__medium",
                      staticStyle: { width: "320px" },
                      on: {
                        click: function ($event) {
                          _vm.modalOpen = true
                        },
                      },
                    },
                    [_vm._v("\n          Read our event guide\n        ")]
                  ),
                ]),
              ]
            : _vm.hasCurrentEvents
            ? [
                _c(
                  "div",
                  { staticClass: "pl-5 flex flex-wrap" },
                  _vm._l(_vm.events, function (event, i) {
                    return _c(
                      "div",
                      { key: event.id, staticClass: "w-full md:w-1/3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pb-6",
                            class: _vm.cardContainerClasses(i),
                          },
                          [_c("event-card", { attrs: { _event: event } })],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm.hasCurrentOrPastEvents
            ? [
                _c(
                  "div",
                  { staticClass: "text-n-gray-dark text-2xl font-hairline" },
                  [_vm._v("\n        You have no upcoming events.\n      ")]
                ),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "text-n-gray-dark text-2xl font-hairline" },
                  [
                    _vm._v(
                      "\n        Create your first virtual or in-person event to engage our shared community.\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-6" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "button button__medium flex-auto md:flex-initial",
                        staticStyle: { width: "320px" },
                        attrs: { to: { name: "event-create" } },
                      },
                      [_vm._v("\n          CREATE YOUR FIRST EVENT!\n        ")]
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("EventGuideModal", {
        model: {
          value: _vm.modalOpen,
          callback: function ($$v) {
            _vm.modalOpen = $$v
          },
          expression: "modalOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-full md:w-1/4" }, [
      _c(
        "h2",
        {
          staticClass:
            "text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6",
        },
        [_vm._v("\n        Events\n      ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }